import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dutchDate',
  standalone: true, 
  pure: true
})
export class DutchDatePipe implements PipeTransform {
  transform(value: string | Date | null | undefined): string {
    if (!value) return '';

    const date = new Date(value);

    return date.toLocaleString('nl-NL', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }
}